import { Injectable } from '@angular/core';
import { signal } from '@angular/core';
import { DialogData } from 'projects/shared/src/lib/core/interfaces/dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  // NOTE 23 sep 2025
  // use a key to keep track of the visible dialog
  // because somethimes there can be multiple <tar-dialog... in the DOM
  // and then all of them will listen to here and become visible if it's a boolean
  // and even though it's the correct one on top, you can see it because the background gets layered
  // and with a key, only one can be visible at a time

  // TODO find a better way then the key
  // perhaps 1 (p-dialog) component in the root
  // and then the service controls when it becomes visible and what is inside?
  // OR use dynamic dialog instead of dialog (with custom service ?)
  // ANSWER use CDK + dialog service
  public visible = signal<string>('');
  public dialogData = signal<DialogData | null>(null);

  public open(key: string, data: DialogData) {
    this.dialogData.set(data);
    this.visible.set(key);
  }

  public close() {
    this.visible.set('');
    const onClose = this.dialogData()?.onClose;
    if (onClose) onClose();
  }
}
